import React from 'react';
import { Box, Button, Grid, IconButton, LinearProgress, Typography, useMediaQuery } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { usePacienteReports } from '../hooks/usePacienteReports';

const getViewRoute = (row) => {
  switch (row.tipo) {
    case 'SPPB y TUG':
      return `/ver-capacidad-funcional/${row.id}/${row.pacienteId}`;
    case 'Fuerza Miembros Superiores':
      return `/ver-valoracion-funcional/${row.id}/${row.pacienteId}`;
    case 'Antropometria':
      return `/ver-antropometria/${row.id}/${row.pacienteId}`;
    case 'Encoder':
      return `/ver-encoder/${row.id}/${row.pacienteId}`;
    case 'Vent':
      return `/ver-vent/${row.id}/${row.pacienteId}`;
    case 'SP':
      return `/ver-sp/${row.id}/${row.pacienteId}`;
    case 'Tesis Torres':
      return `/ver-tesis/${row.id}/${row.pacienteId}`;
    default:
      return null;
  }
};

export default function PacienteReportsTable({ idPaciente }) {
  const { reports, loading, fetchReports } = usePacienteReports({ idPaciente });
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const columns = [
    { field: 'tipo', headerName: 'Tipo', width: 200, flex: 1 },
    { field: 'fecha', headerName: 'Fecha', width: 150 },
    {
      field: 'actions',
      headerName: '',
      width: 80,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const route = getViewRoute(params.row);
        if (!route) return null;
        return (
          <IconButton color="primary" onClick={() => navigate(route)}>
            <VisibilityIcon />
          </IconButton>
        );
      },
    },
  ];

  return (
    <>
      <Typography variant={isMobile ? 'h5' : 'h6'} gutterBottom color="#0D6AEE" sx={{ px: { xs: 0.5, sm: 0 } }}>
        Lista de Informes
      </Typography>
      <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Grid item>
          <Button variant="contained" color="secondary" startIcon={<RestartAltIcon />} onClick={fetchReports} sx={{ borderRadius: 2, width: { xs: '100%', sm: 'auto' } }}>
            Refrescar
          </Button>
        </Grid>
      </Grid>
      {loading ? (
        <LinearProgress />
      ) : (
        <Box sx={{ height: isMobile ? 360 : 400, width: '100%' }}>
          <DataGrid
            rows={reports}
            getRowId={(row) => row.rowId}
            columns={columns}
            initialState={{ pagination: { paginationModel: { pageSize: isMobile ? 5 : 10, page: 0 } } }}
            pageSizeOptions={[5, 10, 25, 50]}
            slots={isMobile ? undefined : { toolbar: GridToolbar }}
            onRowClick={(params) => {
              const route = getViewRoute(params.row);
              if (route) navigate(route);
            }}
            disableRowSelectionOnClick
            disableColumnFilter={isMobile}
            disableColumnSelector={isMobile}
            disableDensitySelector={isMobile}
          />
        </Box>
      )}
    </>
  );
}
